import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
    IApiListParams,
    IBetApiListResponse,
    IRefundBetParams,
    ISetBetResultParams,
    ISetResultPlayerParams,
    ISetResultUsingScoreParams,
    ISkipAutomaticSettlementParams,
    IUnsetResultPlayerParams,
    IVoidBetParams,
} from '@/types';

export const betList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IBetApiListResponse>> => {
    return axios.get('/api/bet/list', { ...config, params });
};

export const setBetResult = (params: ISetBetResultParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/bet/setResult', { rows: [params] });
};

export const refundBets = (params: { rows: IRefundBetParams[] }): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/bet/refund', params);
};

export const voidBets = (params: { rows: IVoidBetParams[] }): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/bet/void', params);
};

export const setResultPlayer = (params: { rows: ISetResultPlayerParams[] }): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/bet/setResultPlayer', params);
};

export const setResultUsingScore = (params: { rows: ISetResultUsingScoreParams[] }): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/bet/setResultUsingScore', params);
};

export const unsetResultPlayer = (params: { rows: IUnsetResultPlayerParams[] }): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/bet/unsetResultPlayer', params);
};

export const skipAutomaticSettlement = (params: { rows: ISkipAutomaticSettlementParams[] }): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/bet/skipAutomaticSettlement', params);
};

export const getBetLogfile = (internalId: string, createdAt: string, fileName?: string): Promise<AxiosResponse<{ success: boolean; file: string }>> => {
    if (fileName) {
        return axios.get('/api/bet/logfile', { params: { internal_id: internalId, created_at: createdAt, fileName } });
    }
    return axios.get('/api/bet/logfile', { params: { internal_id: internalId, created_at: createdAt } });
};

export const betActivity = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IBetApiListResponse>> => {
    return axios.get('/api/bet/activity', { ...config, params });
};

export const betExport = (params: IApiListParams): Promise<AxiosResponse<Blob>> => {
    return axios.get('/api/bet/export', { params, responseType: 'blob' });
};
